// extracted by mini-css-extract-plugin
export var divider = "_yl-0";